import { IconPropsType } from '..';

export const PlayersFillIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.99995 9.18078C8.472 9.18078 9.66534 7.98745 9.66534 6.5154C9.66534 5.04334 8.472 3.85001 6.99995 3.85001C5.5279 3.85001 4.33457 5.04334 4.33457 6.5154C4.33457 7.98745 5.5279 9.18078 6.99995 9.18078Z"
      fill="currentColor"
    />
    <path
      d="M6.99995 0.700012C5.75393 0.700012 4.53589 1.0695 3.49986 1.76175C2.46383 2.45401 1.65634 3.43793 1.17951 4.58911C0.702681 5.74028 0.57792 7.007 0.821007 8.22908C1.06409 9.45116 1.66411 10.5737 2.54518 11.4548C3.42625 12.3359 4.5488 12.9359 5.77088 13.179C6.99296 13.422 8.25968 13.2973 9.41086 12.8205C10.562 12.3436 11.546 11.5361 12.2382 10.5001C12.9305 9.46407 13.3 8.24603 13.3 7.00001C13.2967 5.33013 12.632 3.72956 11.4512 2.54878C10.2704 1.36799 8.66983 0.703214 6.99995 0.700012ZM10.9859 10.5377C10.5936 9.97499 10.0881 9.50043 9.50178 9.14443C8.82856 9.7894 7.93227 10.1495 6.99995 10.1495C6.06764 10.1495 5.17135 9.7894 4.49813 9.14443C3.91178 9.50043 3.40628 9.97499 3.01399 10.5377C2.33176 9.76945 1.88608 8.82041 1.73059 7.8048C1.57509 6.78919 1.71641 5.75027 2.13754 4.8131C2.55866 3.87592 3.24165 3.08041 4.1043 2.5223C4.96695 1.96419 5.9725 1.66727 6.99995 1.66727C8.0274 1.66727 9.03296 1.96419 9.89561 2.5223C10.7583 3.08041 11.4412 3.87592 11.8624 4.8131C12.2835 5.75027 12.4248 6.78919 12.2693 7.8048C12.1138 8.82041 11.6681 9.76945 10.9859 10.5377Z"
      fill="currentColor"
    />
  </svg>
);
